(function () {
  "use strict";

  var MODEL_VIEWER_SCRIPT_URL =
    "https://unpkg.com/@google/model-viewer@3.5.0/dist/model-viewer.min.js";
  var modelViewerScriptPromise = null;

  function getModelUrl(value) {
    return String(value || "").trim();
  }

  function getParts(section) {
    return {
      action: section.querySelector("[data-product-model-open]"),
      thumb: section.querySelector("[data-product-model-thumb]"),
      dialog: section.querySelector("[data-product-model-dialog]"),
      stage: section.querySelector("[data-product-model-stage]"),
    };
  }

  function syncModelThumb(section, modelUrl) {
    var thumb = section.querySelector("[data-product-model-thumb]");

    if (!modelUrl) {
      if (thumb) {
        thumb.remove();
      }
      return null;
    }

    if (thumb) {
      return thumb;
    }

    var thumbsContainer = section.querySelector("[data-product-thumbs]");
    var template = section.querySelector("[data-product-model-thumb-template]");

    if (!thumbsContainer || !template || !template.content) {
      return null;
    }

    thumbsContainer.appendChild(template.content.cloneNode(true));
    return thumbsContainer.querySelector("[data-product-model-thumb]");
  }

  function syncModelSlide(section, modelUrl) {
    var galleryTrack = section.querySelector(
      "[data-product-gallery] .product-page-section__gallery-track",
    );
    var modelSlide = galleryTrack && galleryTrack.querySelector("[data-product-model-slide]");

    if (!modelUrl) {
      if (modelSlide) {
        modelSlide.remove();
      }
      return null;
    }

    if (!galleryTrack) {
      return null;
    }

    if (!modelSlide) {
      var template = section.querySelector("[data-product-model-thumb-template]");
      var placeholder = template && template.content.querySelector("img");
      var placeholderUrl = placeholder ? placeholder.src : "";

      modelSlide = document.createElement("div");
      modelSlide.className = "product-page-section__gallery-slide swiper-slide";
      modelSlide.setAttribute("data-product-model-slide", "");
      modelSlide.dataset.modelPlaceholderUrl = placeholderUrl;
      modelSlide.innerHTML =
        '<div class="product-page-section__gallery-media product-page-section__gallery-media--model">' +
        '<div class="product-page-section__model-stage" data-product-model-gallery-stage aria-busy="false">' +
        (placeholderUrl
          ? '<img class="product-page-section__model-placeholder" src="' +
            placeholderUrl +
            '" alt="">'
          : "") +
        "</div></div>";
      galleryTrack.appendChild(modelSlide);
    }

    if (modelSlide.dataset.model3dUrl !== modelUrl) {
      var modelStage = modelSlide.querySelector("[data-product-model-gallery-stage]");

      if (modelSlide.dataset.model3dUrl) {
        clearModelStage(modelStage);
        showModelPlaceholder(modelStage, modelSlide.dataset.modelPlaceholderUrl);
      }

      modelSlide.dataset.model3dUrl = modelUrl;
      modelSlide.setAttribute("data-media-id", "model-3d-" + modelUrl);
    }

    return modelSlide;
  }

  function syncModelGalleryIndex(section, modelSlide, thumb) {
    var swiper = section.aerofoilsProductGallery;

    if (!modelSlide || !thumb) {
      if (swiper) {
        swiper.allowTouchMove = true;
        if (typeof swiper.update === "function") {
          swiper.update();
        }
      }
      return;
    }

    var slides = Array.prototype.slice.call(
      section.querySelectorAll("[data-product-gallery] .product-page-section__gallery-slide"),
    );
    var slideIndex = slides.indexOf(modelSlide);

    if (slideIndex < 0) {
      return;
    }

    thumb.dataset.thumbIndex = String(slideIndex);
    thumb.dataset.thumbMediaId = modelSlide.getAttribute("data-media-id") || "model-3d";

    if (swiper && typeof swiper.update === "function") {
      swiper.update();

      if (!swiper.aerofoilsModelThumbSyncBound && typeof swiper.on === "function") {
        swiper.aerofoilsModelThumbSyncBound = true;
        swiper.on("slideChange", function () {
          syncModelThumbSelection(section);
        });
      }
    }

    syncModelThumbSelection(section);
  }

  function syncModelThumbSelection(section) {
    var thumb = section.querySelector("[data-product-model-thumb]");
    var modelSlide = section.querySelector("[data-product-model-slide]");
    var swiper = section.aerofoilsProductGallery;

    if (!swiper) {
      return;
    }

    if (!thumb || !modelSlide) {
      swiper.allowTouchMove = true;
      return;
    }

    var modelIndex = Array.prototype.indexOf.call(
      section.querySelectorAll("[data-product-gallery] .product-page-section__gallery-slide"),
      modelSlide,
    );

    var isModelSlideActive = swiper.activeIndex === modelIndex;

    thumb.classList.toggle("is-active", isModelSlideActive);
    swiper.allowTouchMove = !isModelSlideActive;
  }

  function clearModelStage(stage) {
    if (!stage) {
      return;
    }

    stage.dataset.modelRequest = "";
    stage.replaceChildren();
    stage.setAttribute("aria-busy", "false");
  }

  function showModelPlaceholder(stage, placeholderUrl) {
    if (!stage || !placeholderUrl) {
      return;
    }

    var placeholder = document.createElement("img");
    placeholder.className = "product-page-section__model-placeholder";
    placeholder.src = placeholderUrl;
    placeholder.alt = "";
    stage.replaceChildren(placeholder);
  }

  function closeModelDialog(dialog, stage) {
    if (!dialog) {
      return;
    }

    if (dialog.open && typeof dialog.close === "function") {
      dialog.close();
    } else {
      dialog.removeAttribute("open");
      clearModelStage(stage);
    }
  }

  function updateModelAction(section, value) {
    var modelUrl = getModelUrl(value);
    var modelSlide = syncModelSlide(section, modelUrl);
    var thumb = syncModelThumb(section, modelUrl);
    var parts = getParts(section);

    if (!parts.action && !thumb) {
      return;
    }

    [parts.action, thumb].forEach(function (trigger) {
      if (!trigger) {
        return;
      }

      trigger.dataset.model3dUrl = modelUrl;
    });

    if (parts.action) {
      parts.action.hidden = !modelUrl;
    }

    syncModelGalleryIndex(section, modelSlide, thumb);

    if (
      parts.dialog &&
      parts.dialog.open &&
      parts.dialog.dataset.model3dUrl !== modelUrl
    ) {
      closeModelDialog(parts.dialog, parts.stage);
    }
  }

  function loadModelViewer() {
    if (window.customElements && window.customElements.get("model-viewer")) {
      return Promise.resolve();
    }

    if (modelViewerScriptPromise) {
      return modelViewerScriptPromise;
    }

    modelViewerScriptPromise = new Promise(function (resolve, reject) {
      var script = document.createElement("script");
      script.type = "module";
      script.src = MODEL_VIEWER_SCRIPT_URL;
      script.onload = function () {
        if (!window.customElements) {
          reject(new Error("Custom elements are not supported."));
          return;
        }

        window.customElements.whenDefined("model-viewer").then(resolve, reject);
      };
      script.onerror = function () {
        reject(new Error("Unable to load the 3D viewer."));
      };
      document.head.appendChild(script);
    });

    return modelViewerScriptPromise;
  }

  function showMessage(stage, message) {
    if (!stage) {
      return;
    }

    var text = document.createElement("p");
    text.className = "product-page-section__model-status";
    text.textContent = message;
    stage.replaceChildren(text);
    stage.setAttribute("aria-busy", "false");
  }

  function renderModel(stage, modelUrl) {
    if (!stage || !modelUrl) {
      return;
    }

    var requestId = String(Date.now()) + Math.random();

    stage.dataset.modelRequest = requestId;
    stage.setAttribute("aria-busy", "true");
    showMessage(stage, "Loading 3D model...");
    stage.setAttribute("aria-busy", "true");

    loadModelViewer()
      .then(function () {
        if (stage.dataset.modelRequest !== requestId) {
          return;
        }

        var viewer = document.createElement("model-viewer");
        viewer.className = "product-page-section__model-viewer";
        viewer.setAttribute("src", modelUrl);
        viewer.setAttribute("alt", "Interactive 3D product model");
        viewer.setAttribute("camera-controls", "");
        viewer.setAttribute("touch-action", "none");
        viewer.setAttribute("auto-rotate", "");
        viewer.setAttribute("shadow-intensity", "1");
        viewer.setAttribute("loading", "eager");
        viewer.addEventListener(
          "load",
          function () {
            if (stage.dataset.modelRequest === requestId) {
              stage.setAttribute("aria-busy", "false");
            }
          },
          { once: true },
        );
        viewer.addEventListener(
          "error",
          function () {
            if (stage.dataset.modelRequest === requestId) {
              showMessage(stage, "The 3D model could not be loaded.");
            }
          },
          { once: true },
        );
        stage.replaceChildren(viewer);
      })
      .catch(function () {
        if (stage.dataset.modelRequest === requestId) {
          showMessage(stage, "The 3D viewer could not be loaded.");
        }
      });
  }

  function openModelDialog(section) {
    var parts = getParts(section);
    var modelUrl = getModelUrl(
      (parts.action && parts.action.dataset.model3dUrl) ||
        (parts.thumb && parts.thumb.dataset.model3dUrl),
    );

    if (!parts.dialog || !parts.stage || !modelUrl) {
      return;
    }

    parts.dialog.dataset.model3dUrl = modelUrl;
    if (!parts.dialog.open) {
      if (typeof parts.dialog.showModal === "function") {
        parts.dialog.showModal();
      } else {
        parts.dialog.setAttribute("open", "open");
      }
    }

    renderModel(parts.stage, modelUrl);
  }

  function showGalleryModel(section) {
    var parts = getParts(section);
    var modelUrl = getModelUrl(
      (parts.action && parts.action.dataset.model3dUrl) ||
        (parts.thumb && parts.thumb.dataset.model3dUrl),
    );
    var modelSlide = section.querySelector("[data-product-model-slide]");
    var stage = modelSlide && modelSlide.querySelector("[data-product-model-gallery-stage]");

    if (!stage || !modelUrl) {
      return;
    }

    if (modelSlide.dataset.model3dUrl !== modelUrl) {
      return;
    }

    renderModel(stage, modelUrl);
  }

  function initSection(section) {
    if (!section || section.dataset.productModelViewerReady === "true") {
      return;
    }

    var parts = getParts(section);
    if ((!parts.action && !parts.thumb) || !parts.dialog || !parts.stage) {
      return;
    }

    section.dataset.productModelViewerReady = "true";
    updateModelAction(section, section.aerofoilsBundleModel3dUrl);

    if (parts.action) {
      parts.action.addEventListener("click", function () {
        openModelDialog(section);
      });
    }

    var thumbsContainer = section.querySelector("[data-product-thumbs]");
    if (thumbsContainer) {
      thumbsContainer.addEventListener("click", function (event) {
        var thumb = event.target.closest("[data-product-model-thumb]");

        if (thumb && thumbsContainer.contains(thumb)) {
          showGalleryModel(section);
          syncModelThumbSelection(section);
        }
      });
    }

    parts.dialog.addEventListener("close", function () {
      clearModelStage(parts.stage);
    });

    parts.dialog.addEventListener("click", function (event) {
      if (event.target === parts.dialog) {
        closeModelDialog(parts.dialog, parts.stage);
      }
    });

    parts.dialog
      .querySelectorAll("[data-product-model-close]")
      .forEach(function (button) {
        button.addEventListener("click", function () {
          closeModelDialog(parts.dialog, parts.stage);
        });
      });
  }

  function init() {
    document
      .querySelectorAll("[data-product-model-open]")
      .forEach(function (action) {
        initSection(action.closest("[data-product-page-section]"));
      });
  }

  document.addEventListener("aerofoils:bundle-gallery-rendered", function (event) {
    var section = event.target;
    if (
      !section ||
      !section.matches ||
      !section.matches("[data-product-page-section]")
    ) {
      return;
    }

    initSection(section);
    updateModelAction(
      section,
      section.aerofoilsBundleModel3dUrl || (event.detail && event.detail.model3dUrl),
    );
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
